import {CalendarServiceProvider} from "./services/calendar-service/calendar-service";
import {NgModule} from "@angular/core";
import {EventsServiceProvider} from "./services/events-service/events-service";

@NgModule({
  providers: [
    CalendarServiceProvider,
    EventsServiceProvider
  ]
})
export class SellionsCalendarModule {}



// WEBPACK FOOTER //
// ./src/modules/calendar/calendar.module.ts